package streetlight.model.data

import kampfire.api.TableId
import kotlin.uuid.Uuid

/** The id of a record, wrapping its [Uuid]. Each record type has its own. */
sealed interface RecordId: TableId<Uuid> {
    val string get() = value.toString()
}

/** This id as the record id type [T]. Throws for a type that is not registered here. */
inline fun <reified T> Uuid.toRecordId(): T = when (T::class) {
    StarId::class -> StarId(this) as T
    GalaxyId::class -> GalaxyId(this) as T
    ContactId::class -> ContactId(this) as T
    EventId::class -> EventId(this) as T
    LocationId::class -> LocationId(this) as T
    RequestId::class -> RequestId(this) as T
    SongId::class -> SongId(this) as T
    RenditionId::class -> RenditionId(this) as T
    PerformerId::class -> PerformerId(this) as T
    GuestId::class -> GuestId(this) as T
    TalentId::class -> TalentId(this) as T
    PostId::class -> PostId(this) as T
    CommentId::class -> CommentId(this) as T
    EditLogId::class -> EditLogId(this) as T
    TaskId::class -> TaskId(this) as T
    MediaId::class -> MediaId(this) as T
    QuorumId::class -> QuorumId(this) as T
    PolicyId::class -> PolicyId(this) as T
    FlagId::class -> FlagId(this) as T
    FeedbackId::class -> FeedbackId(this) as T
    BugId::class -> BugId(this) as T
    ParserId::class -> ParserId(this) as T
    MessageId::class -> MessageId(this) as T
    ChatId::class -> ChatId(this) as T
    MarkId::class -> MarkId(this) as T
    CityId::class -> CityId(this) as T
    else -> error("invalid recordId type: ${T::class.simpleName}")
}

/** This text parsed as a [Uuid], as the record id type [T]. */
inline fun <reified T> String.toRecordId() = Uuid.parse(this).toRecordId<T>()